import React from 'react';
import { Truck, ClipboardList, BarChart3, ArrowRight } from 'lucide-react';
import type { Step } from '../types';

const HowItWorks: React.FC = () => {
  const steps: Step[] = [
    { number: '01', icon: Truck, title: 'Add Your Fleet', description: 'Import vehicles, drivers, and documents in minutes. Set up your fleet structure with our guided onboarding.' },
    { number: '02', icon: ClipboardList, title: 'Schedule Operations', description: 'Plan trips, assign drivers, set up automated billing rules, and manage contracts—all from one dashboard.' },
    { number: '03', icon: BarChart3, title: 'Track & Optimize', description: 'Monitor costs, view reports, and improve efficiency with real-time insights and automated alerts.' },
  ];

  return (
    <section id="how-it-works" className="section-padding bg-white">
      <div className="container-main">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-h2 mb-6 font-heading">
            Get Started in Three Simple <span className="text-primary-600">Steps</span>
          </h2>
          <p className="text-body-lg text-gray-600">
            From setup to full operation in days, not months. Our intuitive platform gets your fleet running smoothly with minimal training.
          </p>
        </div>
        <div className="relative">
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-gray-200 -z-10">
            <div className="absolute left-1/3 right-1/3 h-full bg-primary-600" />
          </div>
          <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="text-center lg:text-left">
                  <div className="relative inline-block mb-6">
                    <div className="w-20 h-20 bg-primary-600 rounded-2xl flex items-center justify-center shadow-sm relative z-10">
                      <step.icon className="w-8 h-8 text-white" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-accent-orange rounded-full flex items-center justify-center text-white font-bold text-sm shadow-md z-20">{step.number}</div>
                  </div>
                  <h3 className="text-h4 text-navy-950 mb-3 font-heading">{step.title}</h3>
                  <p className="text-body text-gray-600 leading-relaxed">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-16 text-center">
          <a href="/pricing" className="btn-secondary group inline-flex items-center">
            View Pricing
            <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
          </a>
          <p className="mt-4 text-sm text-gray-500">Simple pricing for fleets of all sizes</p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
